<div class="page">
  <app-page-header page-title="companies.list.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'companies.list.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="exportTechnicalFileIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportCompanies')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="name"
                matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="hasNotes">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs"></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <button mat-icon-button (click)="onOpenNotes(element._id)" *ngIf="element.hasNotes">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-exclamation" color="primary"></mat-icon>
                    </button>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="types">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-sm">
                    {{ 'companies.fields.type' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-chip-list class="d-block py-2 px-1">
                      <mat-chip *ngIf="element.types.includes('owner');" color="accent" selected class="mat-chip-sm">
                        {{ 'companies.types.o' | translate }}
                      </mat-chip>
                      <mat-chip *ngIf="element.types.includes('manager');" color="primary" selected class="mat-chip-sm">
                        {{ 'companies.types.m' | translate }}
                      </mat-chip>
                    </mat-chip-list>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="typesFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="manager">{{ 'companies.types.manager' | translate }}</mat-option>
                        <mat-option value="owner">{{ 'companies.types.owner' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(typesFilter)"
                        class="reset-input-icon ml-n3" *ngIf="typesFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-fixed-md">
                    {{ 'companies.fields.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a [routerLink]="'../detail/' + element._id"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ element.name }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="nameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(nameFilter)"
                        class="reset-input-icon" *ngIf="nameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="totalProperties">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">
                    {{ 'companies.fields.totalPropertiesA' | translate }}<br />
                    {{ 'companies.fields.totalPropertiesB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{ element.totalProperties }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="totalPropertiesFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(totalPropertiesFilter)"
                        class="reset-input-icon" *ngIf="totalPropertiesFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">
                    {{ 'companies.fields.email' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{ element.email }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="emailFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(emailFilter)"
                        class="reset-input-icon" *ngIf="emailFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="legalAddressCity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                    title="{{ 'companies.fields.legalAddressCity' | translate }}" class="col-fixed-md column-center">
                    {{ 'common.words.city' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{ element.legalAddress.city }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="legalAddressCityFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilter(legalAddressCityFilter)" class="reset-input-icon"
                        *ngIf="legalAddressCityFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="documentUpload">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">
                    {{ 'companies.fields.disclaimerA' | translate }}<br />
                    {{ 'companies.fields.disclaimerB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <strong style="color: #28a745;" *ngIf="element.subscription && element.subscription.documentUpload">
                      {{ 'common.words.active' | translate }}
                    </strong>
                    <span *ngIf="element.subscription && !element.subscription.documentUpload">{{ 'common.words.dashes' | translate }}</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="documentUploadFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="false">{{ 'common.words.dashes' | translate }}</mat-option>
                        <mat-option value="true">{{ 'common.words.active' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(documentUploadFilter)"
                        class="reset-input-icon ml-n3" *ngIf="documentUploadFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="documentUploadNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-fixed-md column-center">
                    {{ 'companies.fields.disclaimerNumberA' | translate }}<br />
                    {{ 'companies.fields.disclaimerNumberB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{ element.documentUploadNumber }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="documentUploadNumberFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(documentUploadNumberFilter)"
                        class="reset-input-icon" *ngIf="documentUploadNumberFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="privacy">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">
                    {{ 'companies.fields.privacyA' | translate }}<br />
                    {{ 'companies.fields.privacyB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <strong style="color: #28a745;" *ngIf="element.subscription && !element.subscription.privacy && element.subscription.privacySag">
                      {{ 'companies.fields.privacySag' | translate }}
                    </strong>
                    <strong style="color: #28a745;" *ngIf="element.subscription && element.subscription.privacy && !element.subscription.privacySag">
                      {{ 'companies.fields.privacyStandard' | translate }}
                    </strong>
                    <span *ngIf="element.subscription && !element.subscription.privacy && !element.subscription.privacySag">{{ 'common.words.dashes' | translate }}</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="privacyFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="sag">{{ 'companies.fields.privacySag' | translate }}</mat-option>
                        <mat-option value="standard">{{ 'companies.fields.privacyStandard' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(privacyFilter)"
                        class="reset-input-icon ml-n3" *ngIf="privacyFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="privacyNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-fixed-md column-center">
                    {{ 'companies.fields.privacyNumberA' | translate }}<br />
                    {{ 'companies.fields.privacyNumberB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{ element.privacyNumber }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="privacyNumberFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(privacyNumberFilter)"
                        class="reset-input-icon" *ngIf="privacyNumberFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="subscriptionSuppliers">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">
                    {{ 'companies.fields.subscriptionSuppliersA' | translate }}<br />
                    {{ 'companies.fields.subscriptionSuppliersB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <strong style="color: #28a745;" *ngIf="element.subscription && element.subscription.suppliers">
                      {{ 'common.words.active' | translate }}
                    </strong>
                    <span *ngIf="element.subscription && !element.subscription.suppliers">{{ 'common.words.dashes' | translate }}</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="suppliersFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="false">{{ 'common.words.dashes' | translate }}</mat-option>
                        <mat-option value="true">{{ 'common.words.active' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(suppliersFilter)"
                        class="reset-input-icon ml-n3" *ngIf="suppliersFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="subscriptionSuppliersInvoice">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-md column-center">
                    {{ 'companies.fields.subscriptionSuppliersInvoiceA' | translate }}<br />
                    {{ 'companies.fields.subscriptionSuppliersInvoiceB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{ element.subscriptionSuppliersInvoice }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="subscriptionSuppliersInvoiceFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="1">{{ 'common.months.january' | translate }}</mat-option>
                        <mat-option value="2">{{ 'common.months.february' | translate }}</mat-option>
                        <mat-option value="3">{{ 'common.months.march' | translate }}</mat-option>
                        <mat-option value="4">{{ 'common.months.april' | translate }}</mat-option>
                        <mat-option value="5">{{ 'common.months.may' | translate }}</mat-option>
                        <mat-option value="6">{{ 'common.months.june' | translate }}</mat-option>
                        <mat-option value="7">{{ 'common.months.july' | translate }}</mat-option>
                        <mat-option value="8">{{ 'common.months.august' | translate }}</mat-option>
                        <mat-option value="9">{{ 'common.months.september' | translate }}</mat-option>
                        <mat-option value="10">{{ 'common.months.october' | translate }}</mat-option>
                        <mat-option value="11">{{ 'common.months.november' | translate }}</mat-option>
                        <mat-option value="12">{{ 'common.months.december' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(subscriptionSuppliersInvoiceFilter)"
                        class="reset-input-icon ml-n3" *ngIf="subscriptionSuppliersInvoiceFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="subscriptionSuppliersNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-fixed-md column-center">
                    {{ 'companies.fields.subscriptionSuppliersNumberA' | translate }}<br />
                    {{ 'companies.fields.subscriptionSuppliersNumberB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{ element.subscriptionSuppliersNumber }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="subscriptionSuppliersNumberFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(subscriptionSuppliersNumberFilter)"
                        class="reset-input-icon" *ngIf="subscriptionSuppliersNumberFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="subscriptionTagnfc">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">
                    {{ 'companies.fields.subscriptionTagnfcA' | translate }}<br />
                    {{ 'companies.fields.subscriptionTagnfcB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <strong style="color: #28a745;" *ngIf="element.subscription && element.subscription.nfcAccess">
                      {{ 'common.words.active' | translate }}
                    </strong>
                    <span *ngIf="element.subscription && !element.subscription.nfcAccess">{{ 'common.words.dashes' | translate }}</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="nfcAccessFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="false">{{ 'common.words.dashes' | translate }}</mat-option>
                        <mat-option value="true">{{ 'common.words.active' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(nfcAccessFilter)"
                        class="reset-input-icon ml-n3" *ngIf="nfcAccessFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="subscriptionTagnfcInvoice">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-md column-center">
                    {{ 'companies.fields.subscriptionTagnfcInvoiceA' | translate }}<br />
                    {{ 'companies.fields.subscriptionTagnfcInvoiceB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{ element.subscriptionTagnfcInvoice }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="subscriptionTagnfcInvoiceFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="1">{{ 'common.months.january' | translate }}</mat-option>
                        <mat-option value="2">{{ 'common.months.february' | translate }}</mat-option>
                        <mat-option value="3">{{ 'common.months.march' | translate }}</mat-option>
                        <mat-option value="4">{{ 'common.months.april' | translate }}</mat-option>
                        <mat-option value="5">{{ 'common.months.may' | translate }}</mat-option>
                        <mat-option value="6">{{ 'common.months.june' | translate }}</mat-option>
                        <mat-option value="7">{{ 'common.months.july' | translate }}</mat-option>
                        <mat-option value="8">{{ 'common.months.august' | translate }}</mat-option>
                        <mat-option value="9">{{ 'common.months.september' | translate }}</mat-option>
                        <mat-option value="10">{{ 'common.months.october' | translate }}</mat-option>
                        <mat-option value="11">{{ 'common.months.november' | translate }}</mat-option>
                        <mat-option value="12">{{ 'common.months.december' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(subscriptionTagnfcInvoiceFilter)"
                        class="reset-input-icon ml-n3" *ngIf="subscriptionTagnfcInvoiceFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="subscriptionTagnfcNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-fixed-md column-center">
                    {{ 'companies.fields.subscriptionTagnfcNumberA' | translate }}<br />
                    {{ 'companies.fields.subscriptionTagnfcNumberB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">{{ element.subscriptionTagnfcNumber }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="subscriptionTagnfcNumberFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(subscriptionTagnfcNumberFilter)"
                        class="reset-input-icon" *ngIf="subscriptionTagnfcNumberFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'common.words.createdAt' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.createdAt | dateTimeFormat }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="createdAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdAtFilter)"
                        class="reset-input-icon" *ngIf="createdAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5"  class="col-fixed-xs column-center">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                      <a [routerLink]="'../detail/' + element._id" mat-menu-item
                        matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                        {{ 'companies.list.registry' | translate }}
                      </a>
                      <button mat-menu-item *ngIf="loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator'"
                        (click)="onExportTechnicalFile(element._id, element.name)">{{ 'companies.list.technicalFile' | translate }}</button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                 <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->
